import { gql } from '@apollo/client';
import { JobCoreFields } from '../job/job.gql';

export const GET_INTEGRATION_CONNECTIONS_FOR_TENANT = gql`
  query GetIntegrationConnectionsForTenant($tenantId: String!) {
    getIntegrationConnectionsForTenant(tenantId: $tenantId) {
      id
      integrationId
      tenantId
      integrationEnabled
    }
    getIntegrationInitializationSchema {
      integrationId
      platform
    }
  }
`;

export const ASTUTE_GET_OCCUPATION_LIBRARIES = gql`
  query AstuteGetOccupationLibraries($tenantId: String!) {
    ASTUTE_getOccupationLibraries(tenantId: $tenantId) {
      OL_OID
      name
      group
      payRate
      chargeRate
    }
  }
`;

export const ASTUTE_SYNC_JOB_ASSIGNMENT = gql`
  mutation AstuteSyncJobAssignment(
    $jobId: String!
    $occupationLibraryOid: String!
    $poNumber: String
  ) {
    ASTUTE_syncJobAssignment(
      jobId: $jobId
      occupationLibraryOid: $occupationLibraryOid
      poNumber: $poNumber
    ) {
      ...JobCoreFields
    }
  }
  ${JobCoreFields}
`;
